import './App.css';
import 'primereact/resources/primereact.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { Route, Routes } from 'react-router-dom';
import LayoutComponent from './components/common/layout/layout.component';
import HomeComponent from './components/pages/home/home.component';
import AboutUsComponent from './components/pages/about-us/about-us.component';
import NotFoundComponent from './components/pages/not-found/not-found.component';
import ServicesComponent from './components/pages/services/services.component';
import ContactUsComponent from './components/pages/contact-us/contact-us.component';
import LoadingOverlay from './components/common/loading-overlay/loading-overlay.component';
import OpenPositionsComponent from './components/pages/open-positions/open-positions.component';
import CVDownloaderComponent from './components/pages/cv-downloader/cv-downloader.component';
import S3Upload from './components/common/S3-upload/s3-upload.component';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LayoutComponent />}>
          <Route path="home" element={<HomeComponent />}></Route>
          <Route path="services" element={<ServicesComponent />}></Route>
          <Route path="about-us" element={<AboutUsComponent />}></Route>
          <Route path="contact-us" element={<ContactUsComponent />}></Route>
          <Route path="open-positions" element={<OpenPositionsComponent />}></Route>
          <Route path="download-cv" element={<CVDownloaderComponent />}></Route>
          <Route path="test-upload" element={<S3Upload />}></Route>
          <Route path="*" element={<NotFoundComponent />}></Route>
        </Route>
      </Routes>
      <LoadingOverlay />
    </>
  )
  
}

export default App;
